import { upperFirst } from 'lodash';

import { mergeAccountOptions } from 'Domain/schedule-ruleset/helper/mergeAccountOptions';

const getAvailableAccountResponse = (response, rulesetDetail) => {
  if (!response?.availableAccounts) return [];

  const result = mergeAccountOptions(response?.availableAccounts, rulesetDetail);

  return result?.map((item) => {
    return {
      value: item?.id,
      label: `<strong>${upperFirst(item?.name)}</strong> ${item?.ecommerce?.name}`,
    };
  });
};

export default getAvailableAccountResponse;
